/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportViewDto } from '../../models/report-view-dto';

export interface ReportControllerView$Params {
  createdDateFrom?: string;
  createdDateTo?: string;
  updatedDateFrom?: string;
  updatedDateTo?: string;
  housingId?: number;
  officeId?: number;
  subject?: 'Fr\xFChdienst' | 'Nachtdienst' | 'Sp\xE4tdienst' | 'Verlaufsdokumentation';
  id?: number;
  affectedClientsSearch?: string;
  page: number;
  limit: number;
  sortCol?: string;
  sortDir?: 'ASC' | 'DESC';
  deleted?: boolean;
}

export function reportControllerView(http: HttpClient, rootUrl: string, params: ReportControllerView$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReportViewDto>>> {
  const rb = new RequestBuilder(rootUrl, reportControllerView.PATH, 'get');
  if (params) {
    rb.query('createdDateFrom', params.createdDateFrom, {});
    rb.query('createdDateTo', params.createdDateTo, {});
    rb.query('updatedDateFrom', params.updatedDateFrom, {});
    rb.query('updatedDateTo', params.updatedDateTo, {});
    rb.query('housingId', params.housingId, {});
    rb.query('officeId', params.officeId, {});
    rb.query('subject', params.subject, {});
    rb.query('id', params.id, {});
    rb.query('affectedClientsSearch', params.affectedClientsSearch, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('sortCol', params.sortCol, {});
    rb.query('sortDir', params.sortDir, {});
    rb.query('deleted', params.deleted, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReportViewDto>>;
    })
  );
}

reportControllerView.PATH = '/api/report/view';
